import createStore from './create';
import {createInitialStore} from './initialStore';
import isNode from 'detect-node';

export let history;
/* global ___editorData */

export function getNewStore(newStoreData) {
  const newStore = createStore(createInitialStore(newStoreData));
  if (!isNode) {
    require('react-router-redux').syncHistoryWithStore(require('react-router').browserHistory, newStore);
  }
  return newStore;
}
export let store = getNewStore(___editorData);

export const reloadFromInitialData = (initialData) => {
  store = getNewStore(initialData);
};
